<div class="flex h-screen bg-neutral-100">
  <mat-drawer-container class="flex-1" autosize>
    <mat-drawer
      #drawer
      mode="side"
      opened
      class="!w-64 !bg-gradient-to-b !from-primary-800 !to-primary-900 !border-none shadow-2xl"
    >
      <div class="flex flex-col h-full">
        <div
          class="flex items-center gap-3 px-5 py-6 border-b border-white/10 cursor-pointer"
          routerLink="/"
        >
          <div
            class="w-10 h-10 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center p-1.5"
          >
            <img src="/images/vfifc-logo.png" alt="VFIFC" class="w-full h-full object-contain" />
          </div>
          <div class="flex flex-col">
            <span class="text-base font-bold text-white">VFIFC Portal</span>
          </div>
        </div>

        <nav
          class="flex-1 overflow-y-auto py-6 px-3 scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent"
        >
          <ng-container *ngFor="let section of ['Main', 'Applications', 'Management', 'System']">
            <div class="mb-8" *ngIf="hasVisibleItemsInSection(section)">
              <span
                class="block text-xs font-semibold text-primary-200 uppercase tracking-wider px-3 mb-3"
              >
                {{ section }}
              </span>

              <ng-container *ngFor="let item of itemsBySection(section)">
                <ng-container *appHasPermission="item.permissions || []">
                  <button
                    mat-button
                    [routerLink]="item.route"
                    routerLinkActive="active"
                    class="w-full !flex !items-center gap-3 !px-3 !py-2.5 mb-1 !rounded-lg !text-sm !font-medium !text-white/70 !text-left !justify-start !transition-all hover:!bg-white/10 hover:!text-white hover:translate-x-0.5 [&.active]:!bg-white/15 [&.active]:!text-white [&.active]:!font-semibold [&.active]:shadow-lg"
                  >
                    <mat-icon>{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </button>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </nav>

        <div class="px-5 py-4 mt-auto border-t border-white/10">
          <div class="flex items-center justify-between text-2xs text-primary-200">
            <span>Version 1.0.0</span>
            <span>© {{ currentYear }} VFIFC</span>
          </div>
        </div>
      </div>
    </mat-drawer>

    <mat-drawer-content class="bg-white">
      <!-- HEADER: preserved exactly as you had it. -->
      <header
        class="sticky top-0 z-50 bg-white backdrop-blur-md border-b border-neutral-200 shadow-lg"
      >
        <div class="flex items-center justify-between h-16 px-6">
          <div class="flex items-center gap-4">
            <button
              mat-icon-button
              (click)="drawer.toggle()"
              class="!text-neutral-600 hover:!text-primary-600 hover:!bg-primary-50 !transition-all"
            >
              <mat-icon>menu</mat-icon>
            </button>
          </div>

          <div class="flex items-center gap-2">


            <!-- <button
              mat-icon-button
              [matMenuTriggerFor]="notificationMenu"
              class="!text-neutral-600 hover:!text-primary-600 hover:!bg-primary-50 !transition-all"
            >
              <mat-icon
                [matBadge]="notificationCount"
                matBadgeColor="warn"
                [matBadgeHidden]="notificationCount === 0"
                matBadgeSize="small"
                aria-hidden="false"
              >
                notifications
              </mat-icon>
            </button> -->

            <mat-menu #notificationMenu="matMenu" class="mt-2">
              <div class="w-100 max-h-96 overflow-y-auto bg-white">
                <div
                  class="flex justify-between items-center px-4 py-3 border-b border-neutral-200"
                >
                  <span class="text-base font-semibold text-neutral-900">Notifications</span>
                  <button mat-button class="!text-xs !text-primary-600 !font-medium">
                    Mark all read
                  </button>
                </div>
                <button
                  mat-menu-item
                  *ngFor="let notification of notifications"
                  class="!h-auto !py-3 hover:!bg-neutral-50"
                >
                  <div class="flex gap-3 w-full">
                    <div class="w-2 h-2 mt-1.5 rounded-full bg-primary-500 flex-shrink-0"></div>
                    <div class="flex flex-col gap-1 flex-1">
                      <span class="text-sm text-neutral-800 leading-relaxed">{{
                        notification.message
                      }}</span>
                      <span class="text-xs text-neutral-500">{{ notification.time }}</span>
                    </div>
                  </div>
                </button>
                <div class="border-t border-neutral-200 p-2">
                  <button mat-button class="w-full !text-primary-600 !font-medium">
                    View all notifications
                  </button>
                </div>
              </div>
            </mat-menu>

            <button
              mat-button
              [matMenuTriggerFor]="userMenu"
              class="!flex !items-center !gap-2.5 !px-2.5 !py-1.5 !rounded-lg hover:!bg-neutral-100 !transition-all !min-w-0"
            >
              <div
                class="w-9 h-9 rounded-full bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center text-white font-semibold text-sm shadow-md flex-shrink-0"
              >
                {{ currentUser?.name[0] | uppercase }}
              </div>
              <mat-icon class="!text-lg !w-5 !h-5 text-neutral-400 flex-shrink-0"
                >keyboard_arrow_down</mat-icon
              >
            </button>

            <mat-menu #userMenu="matMenu" class="mt-2">
              <div class="w-100 bg-white">
                <div class="flex items-center gap-3 px-4 py-4 border-b border-neutral-200">
                  <div
                    class="w-12 h-12 rounded-full bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center text-white font-bold text-lg shadow-lg"
                  >
                    {{ currentUser?.name[0] | uppercase }}
                  </div>
                  <div class="flex flex-col flex-1">
                    <span class="text-xs font-semibold text-neutral-900">{{
                      currentUser?.name
                    }}</span>
                    <span class="text-sm font-semibold text-neutral-900">{{
                      currentUser?.email
                    }}</span>
                    <span
                      class="text-xs text-white bg-primary-600 px-2 py-0.5 rounded-full inline-block w-fit mt-1"
                      >{{ currentUser?.roles?.[0] || 'ADMIN' }}</span
                    >
                  </div>
                </div>
                <button mat-menu-item class="!py-3" (click)="goToProfile()">
                  <mat-icon class="!text-neutral-600">person</mat-icon>
                  <span class="text-sm">My Profile</span>
                </button>
                <button mat-menu-item class="!py-3" (click)="changePassword()">
                  <mat-icon class="!text-neutral-600">lock</mat-icon>
                  <span class="text-sm">Change Password</span>
                </button>
                <!-- <button mat-menu-item class="!py-3">
                  <mat-icon class="!text-neutral-600">help</mat-icon>
                  <span class="text-sm">Help Center</span>
                </button> -->
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="logout()" class="!py-3 !text-error-600">
                  <mat-icon class="!text-error-600">logout</mat-icon>
                  <span class="text-sm font-medium">Logout</span>
                </button>
              </div>
            </mat-menu>
          </div>
        </div>
      </header>

      <main class="p-6">
        <router-outlet></router-outlet>
      </main>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
